import React from 'react';

import HomePage from '@/components/Pages/Home';
import NotFoundPage from '@/components/Pages/NotFoundPage';
import ProductPage from '@/components/Pages/Product';
import { usePageProps } from '@/hooks';
import { useGetContentQuery } from '@/queries';

function DefaultPage() {
  const { location, intl, params } = usePageProps();
  const { skuSlug, productId } = params;

  const { data } = useGetContentQuery({
    locale: intl.locale,
    pathname: location.pathname,
  });

  if (skuSlug && productId) return <ProductPage />;
  if (data) return <HomePage />;

  return <NotFoundPage />;
}

export default DefaultPage;
